// extracted by mini-css-extract-plugin
module.exports = {"sider":"ChatHistory_sider___I8mm","btn":"ChatHistory_btn__5iXJx"};